import { useMemo, useState } from 'react';
import api from '../api';
import { useApp } from '../App';

const MERCHANT_ROLES = new Set(['company_admin', 'company_owner', 'admin', 'superadmin']);

export default function OfferPublish() {
  const { user, companies, currentCompany, setPage } = useApp();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [budgetAmount, setBudgetAmount] = useState('');
  const [currency, setCurrency] = useState('PLN');
  const [commissionType, setCommissionType] = useState('percent');
  const [commissionRate, setCommissionRate] = useState('10');
  const [commissionFlatAmount, setCommissionFlatAmount] = useState('');
  const [companyId, setCompanyId] = useState(currentCompany?.id || companies?.[0]?.id || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isMerchant = useMemo(() => MERCHANT_ROLES.has(user?.role), [user]);

  async function submit(e) {
    e.preventDefault();
    if (!companyId) return setError('Выбери компанию');
    if (!title.trim()) return setError('Укажи название оффера');
    if (!Number(budgetAmount)) return setError('Укажи бюджет > 0');

    try {
      setLoading(true);
      setError('');
      const payload = {
        company_id: Number(companyId),
        title: title.trim(),
        description: description.trim() || null,
        budget_amount: Number(budgetAmount),
        currency,
        commission_type: commissionType,
        commission_rate: commissionType === 'percent' ? Number(commissionRate || 0) : 0,
        commission_flat_amount: commissionType === 'fixed' ? Number(commissionFlatAmount || 0) : null,
      };
      const { data } = await api.post('/marketplace/offers', payload);
      localStorage.setItem('marketplace_offer_id', String(data.id));
      setPage('offer_details');
    } catch (e2) {
      setError(e2.userMessage || e2.response?.data?.detail || 'Не удалось опубликовать оффер');
    } finally {
      setLoading(false);
    }
  }

  if (!isMerchant) {
    return <div className="card">Эта страница доступна только мерчантам/админам.</div>;
  }

  return (
    <div>
      <div className="page-header">Publish Offer</div>
      <div className="card">
        <form onSubmit={submit} style={{ display: 'grid', gap: 10 }}>
          <label>
            Компания
            <select className="input" value={companyId} onChange={(e) => setCompanyId(e.target.value)}>
              <option value="">Выбрать...</option>
              {(companies || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>

          <label>
            Название
            <input className="input" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Например: 20 лидов на ремонт" />
          </label>

          <label>
            Описание
            <textarea className="input" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Кого ищем, условия, дедлайн" rows={4} />
          </label>

          <label>
            Бюджет
            <input className="input" type="number" step="0.01" min="0" value={budgetAmount} onChange={(e) => setBudgetAmount(e.target.value)} />
          </label>

          <label>
            Валюта
            <input className="input" value={currency} onChange={(e) => setCurrency(e.target.value.toUpperCase())} />
          </label>

          <label>
            Комиссия
            <select className="input" value={commissionType} onChange={(e) => setCommissionType(e.target.value)}>
              <option value="percent">Percent %</option>
              <option value="fixed">Fixed amount</option>
            </select>
          </label>

          {commissionType === 'percent' ? (
            <label>
              Процент комиссии
              <input className="input" type="number" step="0.01" min="0" max="100" value={commissionRate} onChange={(e) => setCommissionRate(e.target.value)} />
            </label>
          ) : (
            <label>
              Фикс комиссия
              <input className="input" type="number" step="0.01" min="0" value={commissionFlatAmount} onChange={(e) => setCommissionFlatAmount(e.target.value)} />
            </label>
          )}

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button type="button" className="btn" onClick={() => setPage('offers')}>← К списку</button>
            <button type="button" className="btn" onClick={() => window.open('https://genro.ai', '_blank', 'noopener,noreferrer')}>Open in Genro AI</button>
            <button className="btn btn-primary" disabled={loading} type="submit">{loading ? 'Публикуем...' : 'Process in Workify CRM'}</button>
          </div>
        </form>

        {error && <div style={{ color: '#ef4444', marginTop: 10 }}>{error}</div>}
      </div>
    </div>
  );
}
